import React from 'react';

import { cx } from '@emotion/css';

interface Props {
  styles: any;
}
export const PrivacyPolicyView = (props: Props) => {
  const { styles } = props;

  return (
    <section className={cx(styles.sec)}>
      <h1 className={cx(styles.h2, styles.title)} style={{ marginBottom: 30 }}>
        Qeeper’s Privacy Policy
      </h1>
      <h4 className={cx(styles.h4, styles.title)} style={{ marginBottom: 30 }}>
        1. Introduction
      </h4>
      <div className={styles.row}>
        <div className={cx(styles.heading_blk)}>
          <h6 className={styles.h6}>
            At qeeper.co.uk, we value your privacy and are committed to
            protecting your personal data. This privacy policy explains how we
            collect, use, and safeguard your personal information when you use
            our services or visit our website.
          </h6>
        </div>
      </div>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        2. Information We Collect
      </h4>
      <h6 className={styles.h6}>
        We collect the following information from you:
      </h6>

      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            <b>Personal Information:</b> When you fill out our contact forms or
            communicate with us, we collect your name, email address, and phone
            number.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Booking Information:</b> When you make a booking, we collect
            information such as your name, address, telephone or mobile phone
            number, email address (used for estimates, booking confirmation, and
            feedback emails), billing information taken for deposits or holding
            credit card information for use in case of cancellations, and any
            comments or feedback you submit.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Usage Data:</b> We gather data on how you use our website to help
            us improve your experience. This may include your IP address,
            browser type, and pages viewed.
          </li>
        </ul>
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        3. How We Use Your Information
      </h4>
      <h6 className={styles.h6}>
        We use your personal information for the following purposes:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            <b>To Provide Our Services:</b> We use your contact details to
            respond to your inquiries and provide our property maintenance
            services.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Customer Support:</b> To assist you with any questions or
            concerns you may have.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Improving Our Services:</b> Usage data helps us understand how
            users interact with our website, enabling us to make improvements.
          </li>
        </ul>
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        4. Sharing Your Information
      </h4>
      <h6 className={styles.h6}>
        We do not sell your personal data to third parties. However, we may
        share your information with trusted third-party service providers who
        help us deliver our services, such as IT support, provided that they
        also comply with data protection regulations.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        5. Data Security
      </h4>
      <h6 className={styles.h6}>
        We take reasonable steps to protect your personal information against
        unauthorised access, alteration, or disclosure. This includes
        implementing industry-standard security measures.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        6. Your Rights
      </h4>
      <h6 className={styles.h6}>You have the right to:</h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            <b>Access:</b> Request a copy of the personal information we hold
            about you.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Correction:</b> Ask us to correct any inaccurate data.
          </li>
          <li style={{ marginTop: 10 }}>
            <b>Deletion:</b> Request the deletion of your personal data, where
            applicable.
          </li>
        </ul>
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        7. Cookies
      </h4>
      <h6 className={styles.h6}>
        Our website uses cookies to enhance your browsing experience. Cookies
        are small files placed on your device that help us analyse site traffic
        and customise content. You can manage your cookie preferences through
        your browser settings.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        8. Changes to This Policy
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        We may update this privacy policy occasionally to reflect changes in our
        practices or legal requirements. The latest version will always be
        available on our website.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        9. Contact Us
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        If you have any questions or concerns about this privacy policy or how
        we handle your personal information, please contact us at:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            <b>Email:</b> request@qeeper.co.uk
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 15 }}>
        Thank you for trusting qeeper.co.uk with your personal information.
      </h6>
    </section>
  );
};
